// src/hooks/useFrameworkControls.js
// Registry-driven control access: keyed by frameworkId via control-sources, with
// no framework-name branching (ADR-2). Selectors over the graph back the new
// relationship features; this hook still serves the grouped-by-category control
// lists the existing UI renders.

import { useMemo } from 'react';
import { getGroupedControls, getControlDetail } from '../data/control-sources';

export const useFrameworkControls = (frameworkId, selectedDomain) => {
  const getCurrentFrameworkControls = useMemo(() => {
    return () => getGroupedControls(frameworkId, selectedDomain);
  }, [frameworkId, selectedDomain]);

  const getControlDetails = (controlId) => getControlDetail(frameworkId, controlId);

  return {
    getCurrentFrameworkControls,
    getControlDetails,
  };
};

export default useFrameworkControls;
